import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KonPermission } from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { Supplier, SupplierBrand } from '../../../../models/supplier.model';
import { DataTableService } from '../../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { SupplierService } from '../../../../services/supplier/supplier.service';

@Component({
    selector: 'app-supplier-brand',
    templateUrl: './supplier-brand.component.html'
})

export class SupplierBrandComponent implements OnInit {

  @Input() supplier: Supplier;
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>();

  private titles: DataTableField[];
  private customButtons: DataTableCustomButton[];
  public perm: KonPermission = new KonPermission();
  modalTitle = '';
  labels = {};
  brands: SupplierBrand[] = [];

  constructor(
    public svc: SupplierService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {

      this.translate.get([
        'common.code',
        'common.brand_id',
        'common.brand_name',
        'common.back'
      ]).subscribe((res) => {
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'brand_id', label: res['common.brand_id'] },
          { id: 'brand_name', label: res['common.brand_name'] },
        ];

        this.customButtons = [{
          callbackname: 'back',
          icon: null,
          isAlwaysEnabled: true,
          label: res['common.back']
          }
        ]

      });
  }

  ngOnInit() {
    this.translate.get([
      'supplierBrandList.add_title',
      'supplierBrandList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['supplierBrandList.add_title'];
      this.labels['edit_title'] = res['supplierBrandList.edit_title'];
    });
    this.reloadList();
    this.perm.edit = false;
    this.perm.view = false;
  }

  reloadList() {
      this.svc.getSupplierBrands(this.supplier.id).subscribe(res => this.brands = res);
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.svc.editing_supplier_brand = data == null ? new Supplier() : data;
  }

  delete (entry): void {
    this.svc.deleteSupplierBrand(this.supplier.id, entry.id).subscribe(() => {
      this.reloadList()
    });
  }

  onAddElement(entry): void {
    entry.supplier_id = this.supplier.id;
    this.svc.postSupplierBrand(this.supplier.id, entry).subscribe(() => {
      this.srvDataTable.get('dt_supplier_brands').showDetail = false;
      this.svc.editing_supplier_brand = null;
      this.reloadList()
    });
  }

  onCustomButton(event) {
    this.onBack.emit();
  }

  onDialogHide () {
    this.svc.editing_supplier_brand = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-brand/supplier-brand.component.ts